import React from 'react';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Popover from '@material-ui/core/Popover';
import PopupState, { bindTrigger, bindPopover } from 'material-ui-popup-state';

import { withAccess } from '~/presentation/hooks/access';
import { Container } from './styles/StyledPopover';

interface ownProps {
  children: JSX.Element;
  content: JSX.Element;
  elevation?: number;
  className?: any;
  classes?: any;
  originX?: 'left' | 'center' | 'right';
  originY?: 'top' | 'center' | 'bottom';
  positionX?: 'left' | 'center' | 'right';
  positionY?: 'top' | 'center' | 'bottom';
  fullWidth?: boolean;
}

export const PopoverPopupState: React.FC<ownProps> = ({
  children,
  content,
  elevation = 0,
  className,
  classes,
  originX = 'center',
  originY = 'bottom',
  positionX = 'center',
  positionY = 'top',
  fullWidth,
}): JSX.Element => {
  return (
    <PopupState variant="popover" popupId="demo-popup-popover">
      {popupState => {
        return (
          <div>
            <Container fullWidth={fullWidth} {...bindTrigger(popupState)}>
              {children}
            </Container>
            <Popover
              className={className}
              classes={classes}
              {...bindPopover(popupState)}
              anchorOrigin={{
                vertical: originY,
                horizontal: originX,
              }}
              transformOrigin={{
                vertical: positionY,
                horizontal: positionX,
              }}
              elevation={elevation}
              onClick={popupState.close}
              onClose={popupState.close}
              style={{ marginTop: '10px' }}
            >
              {content}
            </Popover>
          </div>
        );
      }}
    </PopupState>
  );
};

PopoverPopupState.defaultProps = {
  elevation: 0,
  className: undefined,
  classes: undefined,
  originX: 'center',
  originY: 'bottom',
  positionX: 'center',
  positionY: 'top',
};

export default withAccess(PopoverPopupState);
